import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Auto-hide after 10 seconds
    this.timeout = setTimeout(() => {
      this.close()
    }, 10000)
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  close() {
    // Find all flash-related elements (overlay and modal)
    const overlays = document.querySelectorAll('[data-controller="flash"]')

    overlays.forEach(el => {
      // Add fade-out animation
      el.style.opacity = "0"
      el.style.transform = el.style.transform ? el.style.transform + " scale(0.95)" : "scale(0.95)"
      el.style.transition = "all 0.2s ease-out"
    })

    // Remove elements after animation
    setTimeout(() => {
      overlays.forEach(el => el.remove())
    }, 200)
  }
}
